import { useEffect } from "react";

export function usePagePosition(pageKey: string) {
  useEffect(() => {
    const storageKey = `fp:position:v1:${pageKey}`;
    const saved = Number(localStorage.getItem(storageKey) || 0);
    const restore = window.setTimeout(() => {
      const anchor = window.location.hash ? document.querySelector(window.location.hash) : null;
      if (anchor) anchor.scrollIntoView();
      else window.scrollTo({ top: saved });
    }, 0);
    let frame = 0;
    const record = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        localStorage.setItem(storageKey, String(Math.round(window.scrollY)));
        frame = 0;
      });
    };
    window.addEventListener("scroll", record, { passive: true });
    return () => {
      window.clearTimeout(restore);
      window.removeEventListener("scroll", record);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [pageKey]);
}
